export const getAreaFromCoords = async (lat, lon) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&zoom=10&addressdetails=1`, {
        headers: {
          'User-Agent': 'YourAppName/1.0 (your@email.com)'
        }
      });
  
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
      const data = await res.json();
      const { city = '', town = '', village = '', suburb = '', neighbourhood = '' } = data.address || {};
  
      let areaParts = [neighbourhood, suburb, village, town, city].filter(Boolean);
      return areaParts.length > 0 ? areaParts.join(", ") : "Unknown Area";
    } catch (e) {
      console.error("Error fetching area:", e);
      return "Unknown Area";
    }
  };
  